import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { setRecommendationsList } from '../../../../store/recommendationSlice';
import { getRecommendationsList } from '../../../../api/recommendation';
import RecommendationsTableMedicalLibraryRow from './RecommendationsTableMedicalLibraryRow';
import TableSkeleton from '../../../BaseComponents/TableSkeleton';
import './RecommendationsTable.scss';
import TableHeader from '../../../BaseComponents/TableHeader';
import { toast } from 'react-toastify';

const headerColumns = [
  { title: 'Image', key: 'image', minWidth: '100px', flex: 0 },
  { title: 'Category', key: 'category', minWidth: '150px', flex: 0, sortable: true, apiKey: "category" },
  { title: 'Name', key: 'name', minWidth: '250px', flex: 0, sortable: true, apiKey: "title" },
  { title: 'Description', key: 'description', minWidth: '250px', flex: 1 },
  { title: '', key: 'actions', minWidth: '50px', flex: 0 },
];

const RecommendationsTableMedicalLibrary: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [sortingLoading, setSortingLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<any>(null);
  const { recommendationsList } = useSelector(
    (state: RootState) => state.recommendations
  );
  const [sortedRecommendations, setSortedRecommendations] = React.useState<any>(recommendationsList);

  const fetchRecommendations = useCallback(async (search?: string) => {
      try {
        setLoading(true);
        const recommendationsListResp = await getRecommendationsList(0, 1000, search);
        dispatch(setRecommendationsList(recommendationsListResp));
        // Reset sorted recommendations when fetching new data
        setSortedRecommendations(null);
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    }, [dispatch]);

  const onSort = async (columnKey: string, direction: 'asc' | 'desc') => {
    try {
      // Set sorting loading state immediately
      setSortingLoading(true);
      
      const newRecommendationsList = await getRecommendationsList(0, 1000, '', 'with_doctor_and_nutritionist', columnKey, direction);
      setSortedRecommendations(newRecommendationsList);
    } catch (err) {
      console.error('Error sorting recommendations:', err);
      toast.error('Failed to sort recommendations. Please try again.');
    } finally {
      setSortingLoading(false);
    }
  };

  useEffect(() => {
    fetchRecommendations();
  }, [fetchRecommendations]);

  if (loading) return <div>Loading recommendations...</div>;
  if (error) return <div>Error loading recommendations...</div>;

  const displayBioMarkers = sortedRecommendations ? sortedRecommendations : recommendationsList;
  return (
    <div className='scroll-container recommendations-table'>
      <div className='table-container'>
        <TableHeader headerColumns={headerColumns} gap={'24px'} onSort={onSort} />
        <div className='table-body recommendations-table-body'>
          {sortingLoading ? (
            <TableSkeleton rows={5} columns={5} />
          ) : (
            displayBioMarkers?.recommendations?.map((recommendation:any, index:any) => (
              <RecommendationsTableMedicalLibraryRow
                key={`${recommendation.id}`}
                recommendationData={recommendation}
                recommendationsList={displayBioMarkers?.recommendations}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};
export default RecommendationsTableMedicalLibrary;
